import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Box, { BoxColor } from '@/elements/box/Box';
import { Priority } from './typings';


export default /*#__PURE__*/_defineComponent({
  __name: 'Scorebox',
  props: {
  score: {
    type: Number,
    required: true,
    validator(value: number) {
      // The value must match one of these strings
      return [1, 2, 3].includes(value);
    },
  },
  priority: {
    type: String as () => Priority,
  },
},
  setup(__props) {

const props = __props;

const scoreMap = new Map<number, BoxColor>([
  [1, 'red'],
  [2, 'tangerine'],
  [3, 'green'],
]);

const scoreColor = (score: number) =>
  props.priority == 'none' ? 'transparent' : scoreMap.get(score);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Box), {
    color: scoreColor(__props.score),
    variant: "neutral",
    class: _normalizeClass(["text-center p-2 border border-current rounded-md", {
      'low-priority': __props.priority == 'lower',
    }])
  }, null, 8, ["color", "class"]))
}
}

})